import React, { useState } from "react";
import { FiChevronDown } from "react-icons/fi";
import OutsideClickHandler from "react-outside-click-handler/build/OutsideClickHandler";
import { getAvatarUrl } from "src/Common/common";

const QuotedByDropdown = ({ options = [], defaultOption, onSelect }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [keyword, setKeyword] = useState("");

  const selectedLabel = defaultOption?.name || (typeof defaultOption === "string" ? defaultOption : "Select");
  const selectedAvatar = getAvatarUrl(defaultOption?.avatar);

  const handleOptionClick = (index) => {
    setIsOpen(false);
    onSelect?.(index);
  };

  return (
    <OutsideClickHandler onOutsideClick={() => setIsOpen(false)}>
      <div className="relative w-full">
        <div
          onClick={() => {
            setIsOpen(!isOpen);
          }}
          className="cursor-pointer w-full flex items-center h-[30px] justify-between px-4 py-2 border rounded-[6px] text-gray-800 focus:outline-none focus:border-blue-500"
        >
          <div className="flex items-center gap-2 min-w-0">
            {defaultOption?.avatar && <img src={selectedAvatar} className="w-[15px] h-[15px] rounded-[7.5px]" alt="" />}
            <span className="font-OpenSansRegular text-[400] text-[12px] text-titleColor truncate">
              {selectedLabel}
            </span>
          </div>
          <FiChevronDown className="ml-2" size={15} />
        </div>
        {isOpen && (
          <ul className="absolute z-10 mt-2 w-full bg-white border rounded-md shadow-lg max-h-[300px] overflow-y-auto">
            <div className="w-full h-[30px] border-solid border-b-[1px]  flex items-center justify-center px-[15px]">
              <input
                value={keyword}
                type="text"
                onChange={(e) => {
                  setKeyword(e.target.value);
                }}
                className="w-full text-inputEmailTitle text-[11px] font-[400] font-OpenSansMedium"
                placeholder="Search..."
              />
            </div>
            {/* </li> */}
            {options.map((option, index) => {
              const name = option?.name || "Unnamed user";
              if (keyword && !name.toLowerCase().includes(keyword.toLowerCase())) return null;
              const avatarSrc = getAvatarUrl(option?.avatar);
              return (
                <li
                  key={option?.id ?? index}
                  onClick={() => handleOptionClick(index)}
                  className="px-4 py-2 cursor-pointer hover:bg-gray-200 font-OpenSansRegular text-[12px] flex items-center gap-3"
                >
                  <img src={avatarSrc} className="w-[15px] h-[15px] rounded-[7.5px]" alt="" />
                  <span className="font-OpenSansRegular text-[12px]">{name}</span>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </OutsideClickHandler>
  );
};

export default QuotedByDropdown;
